module.exports = "/* http://sass-lang.com/guide \r\n@import \"~primeng/resources/themes/omega/theme.css\";\r\n@import \"~primeng/resources/primeng.min.css\"; */\r\n/* @import \"~primeng/resources/primeng.min.css\";\r\n@import '~primeng/resources/themes/omega/theme.css'; */"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main